document.addEventListener('DOMContentLoaded', function() {
  const splitSections = document.querySelectorAll('[id^="splitSection-"]');

  splitSections.forEach(section => {
    const video = section.querySelector('.split-video');
    const videoDesktop = video.dataset.videoDesktop;
    const videoMobile = video.dataset.videoMobile;

    if (!video) return;

    // Function to update video source based on screen size
    function updateVideoSource() {
      const isMobile = window.innerWidth <= 768;
      const videoUrl = isMobile ? videoMobile : videoDesktop;

      if (video.src !== videoUrl) {
        video.src = videoUrl;
        video.load();
        
        // Auto-play after loading source
        video.play().catch(err => {
          console.error('[v0] Video autoplay failed:', err);
        });
      }
    }

    // Initial load
    updateVideoSource();

    // Update on window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateVideoSource, 300);
    });

    // Intersection Observer for lazy loading and play control
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Video is in viewport, ensure it plays
          if (video.paused) {
            video.play().catch(err => {
              console.error('[v0] Video play failed:', err);
            });
          }
        } else {
          // Video is out of viewport, pause it to save resources
          if (!video.paused) {
            video.pause();
          }
        }
      });
    }, { threshold: 0.25 });

    observer.observe(section);

    // Apply custom color variables if available
    const sectionSettings = section.parentElement.querySelector('[data-split-settings]');
    if (sectionSettings) {
      const settings = JSON.parse(sectionSettings.dataset.splitSettings);
      section.style.setProperty('--split-primary', settings.headingColor || '#000000');
      section.style.setProperty('--split-text', settings.textColor || '#666666');
      section.style.setProperty('--split-accent', settings.accentColor || '#00BFFF');
    }
  });
});
